// Config del widget. En el camino de lectura, el widget pide esta config
// al backend usando el data-account del snippet. Es info NO sensible
// (apariencia + qué funciones mostrar), por eso es seguro cachearla en el borde.

export interface WidgetConfig {
  color: string;
  position: "left" | "right";
  language: string;
  feedbackEmail: string;
  // Claves de funciones visibles en el panel. Lista vacía = mostrar todas.
  features: string[];
}

// Todas las claves de funciones que el panel puede mostrar (para el dashboard/admin).
export const ALL_FEATURES = [
  // Navegación
  "srMode",
  "keyboardNav",
  "mousegrid",
  "smartNav",
  "tts",
  "voice",
  // Color
  "mono",
  "darkhc",
  "brighthc",
  "lowsat",
  "highsat",
  "contrastMode",
  // Contenido
  "blinks",
  "magnifier",
  "readableFont",
  "imgDesc",
  "links",
  "readableMode",
  "textMag",
  "pageStructure",
  "muteMedia",
  "pageSummary",
  "readFocus",
  "readGuide",
  "dict",
  "vkb",
  "easyRead",
] as const;

export const defaultConfig: WidgetConfig = {
  color: "#2563eb",
  position: "right",
  language: "es",
  feedbackEmail: "clinicabienestar737@gmail.com",
  features: [], // vacío = todas las funciones visibles
};

export async function fetchConfig(
  apiBase: string,
  accountId: string
): Promise<WidgetConfig> {
  const res = await fetch(`${apiBase}/config/${encodeURIComponent(accountId)}`, {
    mode: "cors",
  });
  if (!res.ok) throw new Error(`config ${res.status}`);
  const data = await res.json();
  return { ...defaultConfig, ...data };
}
